<template>
  <v-app>

    <HeaderApp></HeaderApp>
    <v-content>
      <keep-alive>
        <!-- max="2" -->
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
    </v-content>
    <FooterApp />
  </v-app>

</template>

<script>
import HeaderApp from "@/components/HeaderApp";
import FooterApp from "@/components/FooterApp";
import { mapGetters } from "vuex";

export default {
  name: "App",
  metaInfo() {
    return {
      title: this.PARTNER_CONFIG.partner_name

      // meta: [
      //   { property: "og:title", content: this.article.title },
      //   { property: "og:site_name", content: "Website Name" },
      //   { property: "og:type", content: "website" },
      //   { property: "og:url", content: "url.com" },
      //   { property: "og:image", content: this.article.image },
      //   { property: "og:description", content: this.article.description }
      // ]
    };
  },
  components: { HeaderApp, FooterApp },
  computed: {
    ...mapGetters(["PARTNER_CONFIG"])
  }
};
</script>
